import { PersonFilledIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Box } from "@whoosh/design-system/src/components/primitive";

export const IconCard = ({ size }: { size: "sm" | "md" }) => {
  const iconSize = size === "sm" ? 20 : 26;

  return (
    <Box
      backgroundColor="surface-primary"
      width={size === "sm" ? 44 : 72}
      height={size === "sm" ? 44 : 72}
      style={{ borderRadius: size === "sm" ? 12 : 14 }}
      justifyContent="center"
      alignItems="center"
      padding={size === "sm" ? 3 : 6}
      shadowColor="black"
      shadowOffset={{ width: 0, height: 14 }}
      shadowOpacity={0.08}
      shadowRadius={size === "sm" ? 24 : 36}
      elevation={5}
    >
      <PersonFilledIcon width={iconSize} height={iconSize} />
    </Box>
  );
};
